import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders,HttpEvent,HttpEventType,HttpErrorResponse} from "@angular/common/http";
import { AddVideoModel } from '../_models/addVideo';
import { environment } from "../../environments/environment";
import { RouterModule, Routes, Router } from "@angular/router";
import {User} from "../_models/user"




interface dataObj {
  responseCode: any;
  responseMessage: string;
  responsedata: any;
  responseValue: any;
  results: any;
}


@Injectable({
  providedIn: 'root'

})
export class ApiService {
 baseUrl = environment.apiBaseUrl;
 token:any;

  constructor(private httpClient: HttpClient, private router :Router) {
    this.token = -1;
        }

        isEmpty(value) {
          if (value === "" || value === undefined) {
            return true;
          } else {
            return false;
          }
        }

        isValidToken() {
          if (
            this.token < 0 ||
            this.token === false ||
            this.token !== localStorage.getItem("accessToken")
          ) {
            this.token = localStorage.getItem("accessToken")
              ? localStorage.getItem("accessToken")
              : -1;
          }

          if (!this.isEmpty(this.token) && this.token != -1) {
            return true;
          } else {
            this.router.navigate(["/"]);
            return false;
          }
        }

        setHeaders() {
          let httpHeaders = new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("token", this.token);
            // .set("async","false");



          let options = {
            headers: httpHeaders,
          };
          return options;
        }

        isEmptyValue(value) {
          if (
            value === "0" ||
            value === "" ||
            value === 0 ||
            value === undefined ||
            value === null
          ) {
            return true;
          } else {
            return false;
          }
        }


        checkLogin(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + `Login`, data);
        }
        signUp(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + `Register`,data);
        }
        sendOtp(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + `sendOTP`,data );
        }
        createMeeting(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + `createMeeting`, data,{headers: {'token':localStorage.getItem("accessToken")}});
        }
        startMeeting(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + `createMeeting`, data,{headers: {'token':localStorage.getItem("accessToken")}});
        }
        joinMeeting(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + `joinMeeting`, data,{headers: {'token':localStorage.getItem("accessToken")}});
        }
        logout(data) {
          if (this.isValidToken()) {
            let headers = this.setHeaders();
            return this.httpClient.post<dataObj>(this.baseUrl + `logout`, data,headers);
          }
        }

        saveVideo(saveVideo: AddVideoModel) {
          // if (this.isValidToken()) {
          //   let headers = this.setHeaders();
            return this.httpClient.post<dataObj>(this.baseUrl+`saveVideo`, saveVideo);
          // }
        }
        uploadVideo(image) {
          return this.httpClient.post(this.baseUrl+`saveMultipleFile`, image);
        }

        saveMultipleFile(data)  {
          return this.httpClient.post<dataObj>(this.baseUrl + `saveMultipleFile`, data);
        }

        getCategoryList(data) {
          return this.httpClient.post<dataObj>(this.baseUrl + "getCategoryList", data);
        }
        getSubCategoryList(data) {

          return this.httpClient.post<dataObj>(this.baseUrl + "getSubCategoryList", data);
        }
        getAllHostedList(data) {

          return this.httpClient.post<dataObj>(this.baseUrl + "getHostedWebinar", data, {headers: {'token':localStorage.getItem("accessToken")}});
        }
        getAllAttendList(data) {

          return this.httpClient.post<dataObj>(this.baseUrl + "webinarAttendee", data, {headers: {'token':localStorage.getItem("accessToken")}});
        }
        getGroupList(data) {

          return this.httpClient.post<dataObj>(this.baseUrl + "getGroup", data, {headers: {'token':localStorage.getItem("accessToken")}});
        }

        showGroupList(data) {

          return this.httpClient.post<dataObj>(this.baseUrl + "getGroupById", data, {headers: {'token':localStorage.getItem("accessToken")}});
        }

        getdeptData(data) {

          return this.httpClient.post<dataObj>('http://182.156.200.178:121/Api/Employee/GetDepartment', data, {headers: {'accessToken':'7D10A49B394846E695D95483DC5363EB-1'}});
        }
        getemployData(data) {

          return this.httpClient.post<dataObj>('http://182.156.200.178:121/Api/Employee/SearchEmployee', data, {headers: {'accessToken':'7D10A49B394846E695D95483DC5363EB-1'}});
        }
        getcouData(data) {

          return this.httpClient.post<dataObj>('http://182.156.200.179:711/API/CourseMaster/GetAllCourse', data, {headers: {'token':localStorage.getItem("accessToken")}});
        }
        getsesData(data) {

          return this.httpClient.post<dataObj>('http://182.156.200.179:711/API/SessionMaster/GetAllSession', data, {headers: {'token':localStorage.getItem("accessToken")}});
        }
        getstuData(data) {

          return this.httpClient.post<dataObj>('http://182.156.200.179:711/API/StudentAdmissionMaster/GetAllStudentList', data, {headers: {'token':localStorage.getItem("accessToken")}});
        }
        getfacData(data) {

          return this.httpClient.post<dataObj>('http://182.156.200.179:711/API/TeacherMaster/GetAllTeacher', data, {headers: {'token':localStorage.getItem("accessToken")}});
        }
        createWebinar(data) {

          return this.httpClient.post<dataObj>(this.baseUrl + "createWebinar", data, {headers: {'token':localStorage.getItem("accessToken")}});
        }

        // <!--New Service-->


  forgetpassword(data) {
    return this.httpClient.post<dataObj>(this.baseUrl + `forgetpassword`,data);
  }

  userProfile(data) {
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      return this.httpClient.post<dataObj>(this.baseUrl + `getUserById`, data,headers);
    }
  }
  sendFeedback(data) {

    return this.httpClient.post<dataObj>(this.baseUrl + `saveFeedback`, data, {headers: {'token':localStorage.getItem("accessToken")}});
  }
  contactSave(data) {
    return this.httpClient.post<dataObj>(this.baseUrl + `savecontactUs`,data );
  }


  getMemberOfWebinarList(data) {
    // return this.httpClient.post<dataObj>(this.baseUrl + `getUserListByWebinarID`,data );
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      return this.httpClient.post<dataObj>(this.baseUrl + `getUserListByWebinarID`, data,headers);
    }
  }
  deleteWebinar(data) {
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      console.log(data);
      return this.httpClient.post<dataObj>(this.baseUrl + `deleteWebinar`, data,headers);
    }
  }
  getMemberOfMeetingList(data) {
    return this.httpClient.post<dataObj>(this.baseUrl + `getUserListByMeetingID`,data );
  }
  updateWebinar(data) {
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      console.log(data);
      return this.httpClient.post<dataObj>(this.baseUrl + `updateWebinar`, data,headers);
    }
  }
  updateProfile(data) {
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      console.log(data);
      return this.httpClient.post<dataObj>(this.baseUrl + `updateProfile`, data,headers);
    }
  }
  insertUserTransactionLog(data)
  {
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      console.log(data);
      return this.httpClient.post<dataObj>(this.baseUrl + `insertUserTransactionLog`, data,headers);
    }
  }
  getQuestion(data)
  {
    if (this.isValidToken()) {
      //alert(this.isValidToken);
      let headers = this.setHeaders();
      console.log(data);
      return this.httpClient.post<dataObj>(this.baseUrl + `getQuestion`, data,headers);
    }
  }
}
